import { Pipe, PipeTransform } from '@angular/core';
import { DefaultAssetType } from '@thehubz/client/core';
import { AnyType } from '@thehubz/shared/model';

@Pipe({
  name: 'assetTypeTranslation',
  standalone: true,
})
export class AssetTypeTranslationPipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): string {
    let assetType = '';
    const assetTypeIndex = DefaultAssetType.findIndex((type: AnyType) => {
      return type._id === value;
    });
    if (assetTypeIndex != -1) {
      assetType = DefaultAssetType[assetTypeIndex].name;
    }
    return assetType;
  }
}
